import { type InputHTMLAttributes, useId } from 'react';
import { cn } from './cn';

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hint?: string;
}

/** A labelled input: the label is always linked to the input (accessibility). */
export function Field({ label, hint, className, ...input }: FieldProps) {
  const id = useId();
  const hintId = hint ? `${id}-hint` : undefined;
  return (
    <div className={cn('grid gap-1', className)}>
      <label className="text-label font-semibold" htmlFor={id}>
        {label}
      </label>
      <input
        {...input}
        id={id}
        className="min-h-10 rounded-control border border-line bg-surface px-3 text-body text-ink"
        aria-describedby={hintId}
      />
      {hint ? (
        <span className="text-xs text-muted" id={hintId}>
          {hint}
        </span>
      ) : null}
    </div>
  );
}
